<!-- Header con gradiente -->
<div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0;">
  <div class="flex items-center gap-3">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">send</mat-icon>
    <div>
      <h2 style="margin: 0; font-size: 1.25rem; font-weight: 800; color: #1e5a3f;">
        Marcar operación como transferencia enviada
      </h2>
      <span class="font-mono font-bold bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs">
        #{{ transaction?.idTransferencia }}
      </span>
    </div>
  </div>
</div>

<!-- Body -->
<div style="padding: 24px;">

  <!-- Info de la transacción -->
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px;">
      <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Remitente</span>
      <p style="margin: 4px 0 0; font-weight: 700; color: #374151; font-size: 0.9rem;">{{ transaction?.remitente }}</p>
    </div>
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px;">
      <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Beneficiario</span>
      <p style="margin: 4px 0 0; font-weight: 700; color: #374151; font-size: 0.9rem;">{{ transaction?.beneficiario }}</p>
    </div>
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px;">
      <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Tasa Negociación</span>
      <p style="margin: 4px 0 0; font-weight: 700; color: #7c3aed; font-size: 0.9rem;">{{ transaction?.tn }}</p>
    </div>
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px;">
      <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Monto CLP</span>
      <p style="margin: 4px 0 0; font-weight: 700; color: #1e5a3f; font-size: 0.9rem;">{{ transaction?.montoCLP | currency:'$' }}</p>
    </div>
    <div class="sm:col-span-2" style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; padding: 12px;">
      <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Monto USDT</span>
      <p style="margin: 4px 0 0; font-weight: 800; color: #1e5a3f; font-size: 1.1rem;">{{ transaction?.montoUSDT | currency:'$' }}</p>
    </div>
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px;"
      [style.background]="pagoManual ? '#fffbeb' : '#f9fafb'"
      [style.border-color]="pagoManual ? '#fde68a' : '#e5e7eb'">
      <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Red</span>
      <p style="margin: 4px 0 0; font-weight: 700; color: #374151; font-size: 0.9rem;">
        {{ red }}
        <span *ngIf="pagoManual" style="font-size: 0.72rem; font-weight: 700; color: #92400e;">· pago manual</span>
      </p>
    </div>
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px; min-width: 0;">
      <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Wallet</span>
      <p style="margin: 4px 0 0; font-weight: 600; color: #2563eb; font-size: 0.8rem; font-family: monospace; word-break: break-all;">{{ transaction?.walletTRC20 }}</p>
    </div>
  </div>

  <!-- Binance no paga esta red: marcarla es confirmar un pago hecho a mano -->
  <div *ngIf="pagoManual" role="note"
    style="display: flex; align-items: flex-start; gap: 8px; padding: 10px 14px; background: #fffbeb; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px; margin-bottom: 16px;">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; flex-shrink: 0; color: #b45309;">front_hand</mat-icon>
    <span style="font-size: 0.8rem; color: #92400e; line-height: 1.45;">
      Binance no paga la red {{ red }}. Marcala como pagada solo después de enviar los USDT a mano por esa red.
    </span>
  </div>

  <!-- Formulario referencia -->
  <form [formGroup]="datosForm" *ngIf="datosForm">
    <mat-form-field appearance="outline" class="modern-field w-full">
      <mat-label>Referencia</mat-label>
      <mat-icon matPrefix style="color: #6b7280;">tag</mat-icon>
      <input matInput formControlName="referencia" type="text" placeholder="Opcional">
    </mat-form-field>
  </form>

  <!-- Botones -->
  <div class="flex justify-end gap-3 mt-4 pt-4" style="border-top: 1px solid #e5e7eb;">
    <button type="button" (click)="close()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
      onmouseover="this.style.background='#f3f4f6'"
      onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #374151;">close</mat-icon>
      Cancelar
    </button>
    <button type="button" (click)="acceptTransaction()"
      [disabled]="datosForm?.invalid"
      [style.opacity]="datosForm?.invalid ? '0.5' : '1'"
      [style.cursor]="datosForm?.invalid ? 'not-allowed' : 'pointer'"
      style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'"
      onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">check_circle</mat-icon>
      Pagado
    </button>
  </div>
</div>
